import React, { useState, useEffect } from 'react'
import { useSelector } from 'react-redux';
import { useSnackbar } from 'notistack';
// import { QueryBuilder } from "react-querybuilder";
// import "react-querybuilder/dist/query-builder.css";
import { Button, Grid, Paper, Skeleton, Table, TableBody, TableHead, TableRow, TableCell, TableSortLabel, ButtonGroup, } from '@mui/material';
import { AddButton, LeasesBasicDetails, LeasesMenuList, LeasesNav, RemoveButton } from '../../elements';
import { getActivitiesListApi } from '../apiService';
import { trackActivity } from '../../../utils/mixpanel';
import { NoRecordFound, PageLoader, Pagination, STableLoader, FilterComponent } from '../../../shared_elements';
import ModuleNotExcessModal from '../../../shared_elements/components/ModuleNotExcessModal';
import { globalGetService } from '../../../utils/globalApiServices';
import { checkApiStatus } from '../../../utils';
import ActivitiesListing from '../components/ActivitiesListing';
import CustomDatePopover from '../components/CustomDatePopover';
import moment from 'moment';
import { getDateRange, selectOps, textOps } from '../../../utils/helper';
import BackToLeaseList from '../../elements/BackToLeaseList';
import { useParams } from 'react-router';



const activityTypeOptions = [
  { label: 'Create', value: 'create' },
  { label: 'Update', value: 'update' },
  { label: 'Delete', value: 'delete' },
  { label: 'Export', value: 'export'}
];

const activitiesFilterMenu = {
  module_display_name: { title: 'Module Name', inputType: 'text' },
  activity_type: { title: 'Activity Type', inputType: 'dropdown', options: activityTypeOptions, valueKey: 'value', labelKey: 'label', multiple: false },
  os_name: { title: 'OS Name', inputType: 'text' },
  browser_name: { title: 'Browser Name', inputType: 'text' },
  performed_by: { title: "Performed By", inputType: 'text'},
  performed_at_after: { title: 'Performed From', inputType: 'date' },
  performed_at_before: { title: 'Performed To', inputType: 'date' },
};

const ActivitiesHd = ({ sortInfo, createSortHandler }) => {
  const handleItemClicked = (page_type) => {
    trackActivity('Item Clicked', { page_title: `Activities`, page_type: page_type, })
  }
  const tableSorting = (key, name) => {
    return (
      <TableSortLabel
        active={sortInfo.sort_by === key ? true : false}
        direction={sortInfo.sort_by === key ? sortInfo.sort : 'asc'}
        onClick={() => { createSortHandler(key); handleItemClicked(`Table Sorting: ${name}`) }}
      >
        {name}
      </TableSortLabel>
    )
  }
  return (
    <TableHead>
      <TableRow>
        <TableCell sx={{ minWidth: "270px" }}>Activity Info</TableCell>
        <TableCell sx={{ minWidth: "140px" }}>{tableSorting('module_name', 'Module Name')}</TableCell>
        <TableCell sx={{ minWidth: "110px" }}>{tableSorting('activity_type', 'Activity Type ')}</TableCell>
        <TableCell sx={{ minWidth: "220px" }}>{tableSorting('performed_by', 'Performed By')}    </TableCell>
        <TableCell sx={{ minWidth: "140px" }}>{tableSorting('performed_at', 'Performed At')}</TableCell>
        <TableCell sx={{ minWidth: "120px" }}>Device IP</TableCell>
        <TableCell sx={{ minWidth: "110px" }}>Device Type</TableCell>
        <TableCell sx={{ minWidth: "120px" }}>Browser Type</TableCell>
        <TableCell sx={{ minWidth: "110px" }}>OS Type</TableCell>
      </TableRow>
    </TableHead>
  )
}

const Activities = () => {
  const { leaseSlug } = useParams();
  const params = { leaseSlug: leaseSlug };
  const { enqueueSnackbar } = useSnackbar()
  const { leaseBasicDetails } = useSelector((state) => state.leases);
  const [skeletonLoader, setSkeletonLoader] = useState(true);
  const [activitiesData, setActivitiesData] = useState({ mode: true })
  const [isLoading, setLoading] = useState(false);
  const [popoverData, setPopoverData] = useState({ modal: false, data: {} });
  const [customDateData, setCustomDateData] = useState({});
  const [dateFilterkey, setDateFilterKey] = useState("");
  const [error, setError] = useState({});
  const [filter, setFilter] = useState({});
  const [queryConfig, setQueryConfig] = useState({
    page: activitiesData?.pagination?.page || 1,
    per_page: activitiesData?.pagination?.per_page || 50,
  });
  const [filterQuery, setFilterQuery] = useState({
    combinator: "and",
    rules: []
  });
  const [qbFields, setQbFields] = useState([]);
  const [isExport, setExport] = useState();

  useEffect(() => {
    trackActivity('Page Viewed', { page_title: 'Activities' })
  }, [])
  useEffect(() => {
    if (!leaseBasicDetails?.status) return;
    getActivitiesList({ per_page: 50, lease_slug: params?.leaseSlug }, 'skeletonLoader');
  }, [leaseBasicDetails?.status])

  const onToggleModal = () => { setCustomDateData({}); setError({}); setPopoverData({ modal: false, event: null }) }
  const getActivitiesList = (query = {}, loaderType) => {
    loaderType === 'skeletonLoader' ? setSkeletonLoader(true) : setLoading(true);
    if(leaseBasicDetails?.id){
      globalGetService(getActivitiesListApi(query)).then(response => {
      if (checkApiStatus(response)) {
        setActivitiesData(response?.data?.data);
        if (checkApiStatus(response)) {
          const list = response?.data?.data?.list || [];
          setActivitiesData(response?.data?.data);

          // Build dynamic dropdown values
          const activityTypeValues = [
            ...new Map(
              list.map(item => [
                item.activity_type,
                {
                  name: item.activity_type,
                  label: item.activity_type_display
                }
              ])
            ).values()
          ];

          const moduleValues = [
            ...new Map(
              list.map(item => [
                item.module_name,
                {
                  name: item.module_name,
                  label: item.module_display_name
                }
              ])
            ).values()
          ];

          setQbFields([
            {
              name: "asset",
              label: "Asset",
              valueEditorType: "text",
              operators: textOps
            },
            {
              name: "module_name",
              label: "Module Name",
              valueEditorType: "select",
              operators: selectOps,
              values: moduleValues
            },
            {
              name: "activity_type",
              label: "Activity Type",
              valueEditorType: "select",
              operators: selectOps,
              values: activityTypeValues
            }
          ]);
        }

        loaderType === 'skeletonLoader' ? setSkeletonLoader(false) : setLoading(false);
        onToggleModal()
      }
    })
    }
  }

  const onApplyFilter = (query) => {
    setFilter(query);
    getActivitiesList({lease_slug: params?.leaseSlug, ...queryConfig, ...query, page: 1, per_page: activitiesData?.pagination?.per_page || 50 });
  };

  const onFieldChange = (key, value) => { setCustomDateData({ ...customDateData, [key]: value }) }
  const onFocusChange = (key) => { setError({ ...error, [key]: "" }) }
  const createSortHandler = (key) => {
    const isAsc = queryConfig.sort_by === key && queryConfig.sort === 'asc';
    const updatedSort = isAsc ? 'desc' : 'asc';
    setQueryConfig({
      ...queryConfig,
      page: activitiesData?.pagination?.page || 1,
      per_page: activitiesData?.pagination?.per_page || 50,
      sort_by: key,
      sort: updatedSort
    });
    getActivitiesList({
      ...filter,
      ...queryConfig,
      page: activitiesData?.pagination?.page || 1,
      per_page: activitiesData?.pagination?.per_page || 50,
      sort: updatedSort,
      sort_by: key,
      lease_slug: params?.leaseSlug
    }, "");
  };
  const onCustomDateApply = (key) => {
    setDateFilterKey(key)
    if (key === "is_custom") {
      const startDate = moment(customDateData?.start_date);
      const endDate = moment(customDateData?.end_date);
      const validationInputs = {
        start_date: customDateData?.start_date && startDate.isValid() ? "" : "Please enter valid Start Date",
        end_date: customDateData?.end_date && endDate.isValid() ? "" : "Please enter valid End Date",
      };
      if (customDateData?.start_date && customDateData?.end_date && startDate.isValid() && endDate.isValid()) {
        validationInputs['end_date'] = endDate.isBefore(startDate) ? "End Date must be after Start Date" : "";
      }
      if (Object.keys(validationInputs).every((k) => { return validationInputs[k] === ""; })) {
        const query = { performed_at_before: customDateData?.end_date ? customDateData?.end_date : null, performed_at_after: customDateData.start_date ? customDateData.start_date : null }
        setQueryConfig({ ...queryConfig, ...query,page: 1 });
        getActivitiesList({ lease_slug: params?.leaseSlug,...filter, ...queryConfig, ...query,page: 1 })
      } else {
        setError(validationInputs);
      }
    } else {
      const query = { performed_at_after: getDateRange(key)?.start ? getDateRange(key)?.start : null, performed_at_before: getDateRange(key)?.end ? getDateRange(key)?.end : null }
      setQueryConfig({ ...queryConfig, ...query,page: 1 });
      getActivitiesList({lease_slug: params?.leaseSlug, ...filter, ...queryConfig, ...query,page: 1 })
    }
  }

  const handleExport = (query) => {
    setExport(true);
    globalGetService(getActivitiesList(query, "pageLoader")).then((response) => {
      if (checkApiStatus(response)) {
        enqueueSnackbar(response?.data?.message, { variant: "success", anchorOrigin: { vertical: "top", horizontal: "right" } });
      }
      setExport(false);
    })
  }

  const handleClearDateFilter = () => {
    setDateFilterKey("")
    setQueryConfig({
      page: queryConfig?.pagination?.page || 1,
      per_page: queryConfig?.pagination?.per_page || 50,
    })
    getActivitiesList({
      ...filter,
      lease_slug: params?.leaseSlug,
      page: queryConfig?.pagination?.page || 1,
      per_page: queryConfig?.pagination?.per_page || 50,
    })
  };

  const mapFieldToApi = {
    asset: "hierarchy.data.asset.msn",
    module_name: "module_name",
    activity_type: "activity_type"
  };

  const applyFilters = () => {
    const filters = [];

    const walk = (node) => {
      if (node.rules) {
        node.rules.forEach(walk);
      } else {
        filters.push({
          field: mapFieldToApi[node.field],
          operator: node.operator,
          value: node.value
        });
      }
    };

    walk(filterQuery);

    const filterPayload = {
      ...queryConfig,
      filters: JSON.stringify({
        combinator: filterQuery.combinator,
        rules: filters
      })
    };

    // getActivitiesList(filterPayload);
  };

  const handleItemClicked = (page_type) => {
    trackActivity('Item Clicked', { page_title: `Activities`, page_type: page_type, })
  }

  return (
    <>
      <LeasesBasicDetails />
      <Paper className='lease-details-section lease-nav-module-margin lease-module-paper' elevation={0}>
        <LeasesNav />
        {leaseBasicDetails && Object.keys(leaseBasicDetails).length > 0 && !leaseBasicDetails?.status ? (<ModuleNotExcessModal leaseNotFound />) :
          <div className='lease-details-content'>
            <Paper square className="responsive-paper">
              <Grid container spacing={1} className="responsive-grid" alignItems='end' sx={{ justifyContent: 'space-between',placeItems:"flex-start" }}>
                <Grid item size={{ md: 12, xs: 12 }} sx={{mb:-1}} className="menu-container lease-list-link-mt">
                  <BackToLeaseList/>
                </Grid>
                 <Grid size='grow' sx={{ minWidth: 0 }}>
                {skeletonLoader ? <Skeleton variant="rounded" width={220} height={32} /> : <div style={{ marginLeft:"-5px"}}><FilterComponent filter={filter} filterMenu={activitiesFilterMenu} getResponseBack={onApplyFilter} /></div>}
              </Grid>
                <Grid item md='auto' xs={12}>
                  {skeletonLoader ? <Skeleton variant="rounded" width={220} height={32} /> :
                  <ul className='list-inline lease-details-right-items lease-details-btn' style={{ margin: 0,padding:'0px' }}>
                    <ButtonGroup variant="outlined">
                      <Button className='alert-btn-group' size="small" variant={dateFilterkey === "is_custom" ? "contained" : "outlined"} color="primary" onClick={(event) => { setPopoverData({ event: event.currentTarget, modal: true }); handleItemClicked('Clicked on Custom Date') }}>Custom Date</Button>
                      <Button className='alert-btn-group' size="small" variant={dateFilterkey === "today" ? "contained" : "outlined"} color="primary" onClick={() => { onCustomDateApply("today"); handleItemClicked('Clicked on Today Button') }}>Today</Button>
                      <Button className='alert-btn-group' size="small" variant={dateFilterkey === "yesterday" ? "contained" : "outlined"} color="primary" onClick={() => { onCustomDateApply("yesterday"); handleItemClicked('Clicked on Yesterday Button') }}>Yesterday</Button>
                      <Button className='alert-btn-group' size="small" variant={dateFilterkey === "7days" ? "contained" : "outlined"} color="primary" onClick={() => { onCustomDateApply("7days"); handleItemClicked('Clicked on 7 Days Button') }}>7 Days</Button>
                      <Button className='alert-btn-group' size="small" variant={dateFilterkey === "1month" ? "contained" : "outlined"} color="primary" onClick={() => { onCustomDateApply("1month"); handleItemClicked('Clicked on 1M Button') }} >1M</Button>
                      {dateFilterkey && <Button size="small" color="error" variant={"outlined"} onClick={() => { handleClearDateFilter(); handleItemClicked('Clicked on Clear Button') }}>Clear</Button>}
                    </ButtonGroup>
                  </ul>}
                </Grid>
              </Grid>
            </Paper>
            <div className='lease-detail-table'>
              {/* <Grid item xs={12}>
              <Paper sx={{ p: 1, mt: 1, mb: 1 }} variant="outlined">
                <QueryBuilder
                  fields={qbFields}
                  query={filterQuery}
                  onQueryChange={setFilterQuery}
                  showCombinatorsBetweenRules
                  controlElements={{
                    addRuleAction: AddButton,
                    addGroupAction: AddButton,
                    removeRuleAction: RemoveButton,
                    removeGroupAction: RemoveButton
                  }}
                />
                <Button
                  variant="contained"
                  size="small"
                  sx={{ mt: 1 }}
                  onClick={() => applyFilters()}
                >
                  Apply Filters
                </Button>
              </Paper>
            </Grid> */}
              {skeletonLoader ? <STableLoader count={6} rowCount={10} /> :
                <>
                  <Paper className='table-container' sx={{ ...(activitiesData?.list?.length > 0
                    ? { height: 'calc(100vh - 270px) !important' }
                    : { height: 'auto !important', maxHeight: 'calc(100vh - 270px) !important' }
                  ) }}>
                    <Table className="mui-table-format" stickyHeader>
                      <ActivitiesHd sortInfo={queryConfig} createSortHandler={createSortHandler} />
                      <TableBody>
                        {activitiesData?.list?.length > 0 && activitiesData?.list?.map((item, index) => {
                          return (
                            <ActivitiesListing
                              item={item}
                              key={index}
                            />
                          )
                        })}
                      </TableBody>
                    </Table>
                  </Paper>
                  {activitiesData?.list?.length === 0 && <NoRecordFound />}
                  <Paper>
                    <Pagination
                      pagination={activitiesData?.pagination}
                      onPageChange={(event, newPage) => {
                        const pageNum = newPage + 1;
                        setQueryConfig({ ...queryConfig, page: pageNum, per_page: activitiesData?.pagination?.per_page });
                        getActivitiesList({lease_slug: params?.leaseSlug, ...filter, ...queryConfig, page: pageNum, per_page: activitiesData?.pagination?.per_page });
                      }}
                      onRowsPerPageChange={(e) => {
                        const perPage = Number(e.target.value);
                        setQueryConfig({ ...queryConfig, page: 1, per_page: perPage });
                        getActivitiesList({lease_slug: params?.leaseSlug, ...filter, ...queryConfig, page: 1, per_page: perPage });
                      }} />
                  </Paper>
                </>}
            </div>
          </div>}
      </Paper>
      {popoverData?.modal ? <CustomDatePopover customDateData={customDateData} popoverData={popoverData} error={error} onFieldChange={onFieldChange} onFocusChange={onFocusChange} onCustomDateApply={onCustomDateApply} onToggleModal={onToggleModal} /> : null}
      {isLoading ? <PageLoader /> : null}
    </>
  )
}

export default Activities;
